import { useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";

const SettingsTab = (props) => {
  const { eventId } = useParams();
  const { isEdit, data } = useSelector((state) => state.event);
  const tabData = [
    { id: "settings", title: "Settings", link: "" },
    { id: "instructions", title: "Instructions", link: "instructions" },
    { id: "emailsms", title: "Email", link: "email-sms" },
  ];
  const indexTab = tabData.findIndex((tab) => tab.id === props.Id);

  return (
    <nav className="event-settings-subtabs" aria-label="Settings sections">
      {tabData.map((tab, index) => {
        if (isEdit === false && eventId === data._id && indexTab < index) {
          return null;
        }

        let className = "event-settings-subtab";
        if (props.Id === tab.id) {
          className += " is-active";
        } else if (indexTab > index) {
          className += " is-complete";
        }

        return (
          <Link
            key={tab.id}
            id={tab.id}
            className={className}
            to={`/myEvents/${eventId}/settings/${tab.link}`}
          >
            {tab.title}
          </Link>
        );
      })}
    </nav>
  );
};

export default SettingsTab;
